import { useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { useCallback, useMemo } from 'react'

export interface QueryObj {
  [key: string]: string | number
}

export interface QueryParsed {
  [key: string]: string
}
export const useQuery = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParsed = useMemo(
    () => queryString.parse(location.search),
    [location.search],
  ) as QueryParsed

  const updateQuery = useCallback(
    (query: QueryObj) => {
      const stringify = queryString.stringify({
        ...queryString.parse(window.location.search),
        ...query,
      })
      navigate(`?${stringify}`)
    },
    [navigate],
  )

  const replaceQuery = (query: QueryObj) => {
    const stringify = queryString.stringify(query)
    navigate(`?${stringify}`, { replace: true })
  }
  const removeQuery = (keys: string[]) => {
    const updatedQuery = { ...queryParsed }
    keys.forEach((el) => {
      delete updatedQuery[el]
    })
    const stringify = queryString.stringify(updatedQuery)
    navigate(`?${stringify}`, { replace: true })
  }
  const updateFilter = useCallback(
    (query: QueryObj) => {
      const stringify = queryString.stringify({
        ...queryParsed,
        ...query,
        page: 1,
      })
      navigate(`?${stringify}`, { replace: true })
    },
    [queryParsed, navigate],
  )
  return {
    queryParsed,
    updateQuery,
    replaceQuery,
    removeQuery,
    updateFilter,
    rawQueryParams: location.search,
  }
}
